module.exports = __webpack_public_path__ + "media/images/lig/products/lig-product-08-b50007f4956368bc14bfdaa1b256d528.jpg";